<div class="row align-items-center p-2">

    <div class="ms-3 circle col-auto" [ngStyle]="{'background-color':  circleColor }">
        @if (!showInitials) {
        <img src="{{photoUrl}}">
        }
        @if (showInitials) {
        <div class="initials">
            {{ initials }}
        </div>
        }
    </div>
    <span class="col" [ngStyle]="{ 'font-weight': IsBold ? 'bold' : '100'}">
        {{FirstName}} {{LastName}}
    </span>

</div>